<template>
  <q-page class="row">
    <div class="q-pa-md">
      <q-card class="my-card">
        <q-toolbar class="text-primary">
          <q-toolbar-title cypress="title" class="q-mr-xl">
            Séances
          </q-toolbar-title>
          <q-btn color="secondary" icon-right="add" label="Nouvelle séance" @click="addSeance()" :disable="remainingSessions<=0" class="q-mr-sm">
            <q-tooltip v-if="remainingSessions<=0" content-class="bg-accent">Vous avez épuisé vos quotas de séance. Vous devez en acquérir de nouveaux</q-tooltip>
          </q-btn>
          <q-btn color="primary" icon-right="add" label="Démo" @click="addSeance(true)">
            <q-tooltip>Ce type de séance ne peut servir que dans le cadre d'une démonstration</q-tooltip>
          </q-btn>
        </q-toolbar>
        <q-separator />

        <q-markup-table v-if="seances.length">
          <thead>
            <tr>
              <th class="text-left">Code d'accès</th>
              <th class="text-left">Gérer</th>
              <th class="text-left" >Rejoindre la séance</th>
              <th class="text-left">Chiffre d'affaire</th>
              <th class="text-left"></th>
              
            </tr>
          </thead>
          <tbody>
            <template v-for="seance in seances" >
              <tr cypress="drinkList" :key="seance.id">
                <td class="text-left text-capitalize text-weight-medium">
                  {{seance.code_acces}}
                  <q-icon name="warning" class="text-red" size="sm" v-if="seance.is_demo">
                    <q-tooltip>Cette séance est une séance de démo</q-tooltip>
                  </q-icon>
                </td>
                <td class="text-left text-capitalize text-weight-medium">
                  <router-link :to="{name: 'seance', params: {id: seance.id}}">
                    <q-btn 
                      color="blue"  
                      label="Gérer"/>
                  </router-link>
                </td>
                <td class="text-left  text-weight-medium">
                  <router-link :to="{name: 'liveSeance', params: {id: seance.id}}" v-if="seance.running || seance.opened">
                    <q-btn 
                      color="blue"  
                      label="Rejoindre"
                    />
                  </router-link>
                  <template v-else class="text-capitalize">Séance terminée</template>
                </td>
                <td class="text-right text-capitalize text-weight-medium">{{seance.CA ? seance.CA.toFixed(2) : 0}} € </td>
                <td class="text-right">
                  <q-btn 
                    color="red" 
                    icon-right="delete" 
                    label="" 
                    :disabled="(seance.running || seance.closed) && !seance.is_demo"
                    :title=" seance.running || seance.closed ? 'Vous ne pouvez pas supprimer une séance qui est soit en cours soit déjà terminée' : 'Supprimer'"
                    @click="showDeleteSeance(seance.id)"/>
                </td>
              </tr>
            </template>
            <tr class="bg-grey-3"> 
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td> <b>CA Total :</b> </td>
              <td class = "text-left text-capitalize text-weight-medium">{{totalCa.toFixed(2)}} €</td>
            </tr>
          </tbody>
        </q-markup-table>
      </q-card>
    </div>
    <DeleteSeance 
      :seance="seance" 
      :show="show"
      @delete="deleteSeanceMethod"
      @cancel="cancelDelete"/>
  </q-page>
</template>

<script>
import { mapState } from 'vuex';
import DeleteSeance from '~/components/DeleteSeance.vue';
import { createSeance, getAllSeances, deleteSeance, getTotalPriceBySeance } from "~/services/seances";
import { getSubscription } from "~/services/user"
import { baseUrl, base_url_seances } from '~/variables';
import ReconnectingEventSource from "reconnecting-eventsource";

export default {
  name: "Home",
  components: {
    DeleteSeance,
  },
  data() {
    return {
      seances: [],
      seance: {},
      show: false,
      total_CA: 0.00,
      remainingSessions: 0
    }
  },
  async created() {
    const respSubscription = await getSubscription(this.user.abonnement)
    if (respSubscription.status === 200) {
      console.log(respSubscription)
      this.remainingSessions = respSubscription.data.remaining_sessions
    }

    console.log("test")
    const respSessions = await getAllSeances();
    console.log(respSessions)
    this.seances = respSessions.data;
    for (let index = 0; index < this.seances.length; index++) {
      let seance = this.seances[index]
      let response = await getTotalPriceBySeance(this.seances[index].id)
      seance.CA = response.data.total_price
      this.$set(this.seances, index, seance)
      this.total_CA += seance.CA
    }
    this.total_CA = Number.parseFloat(this.total_CA).toFixed(2)
    
  },
  methods: {
    resetVars() {
      this.seance = {}
    },
    async addSeance(demo=false) {
      const resp = await createSeance({abonnement: this.user.abonnement, is_demo: demo});
      this.$q.loading.show({
        message: 'La séance est en cours de création'
      })
      if(resp.status === 201) {
        this.$q.loading.hide();
        this.$router.push({name: 'seance', params: {id: resp.data.id}})
      } else {
        this.$q.loading.hide()
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: resp.data,
          position: 'top-right'
        });
      }
    },
    showDeleteSeance(id) {
      this.show = true;
      this.seance = this.seances.filter(e => e.id === id)[0];
    },
    async deleteSeanceMethod() {
      this.$q.loading.show({
        message: 'La séance est en cours de suppression'
      });
      const resp = await deleteSeance(this.seance);
      if (resp.status === 204) {
        this.$q.loading.hide();
        let indexToDelete = this.seances.findIndex(e => e.id === this.seance.id);
        this.seances.splice(indexToDelete, 1);
        this.show = false;
        this.resetVars();
      } else {
        this.$q.loading.hide()
        this.show = false;
        this.$q.notify({
          color: 'red-4',
          textColor: 'white',
          icon: 'fas fa-exclamation-circle',
          message: 'Impossible de supprimer une séance qui est soit en cours soit déjà terminée',
          position: 'top-right'
        });
      }
    },
    cancelDelete() {
      this.show = false;
      this.resetVars()
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
    }),
    totalCa: function () {
      let value = 0
      this.seances.forEach(element => {
        if (element.CA) {
          value += element.CA
        }
      })
      return value
    }
  },
};
</script>

<style></style>
